import { useState, useEffect } from "react";
import { useStore } from "store";
import { useWindowDimensions } from "resources/BrowserManager";
import ApiManager from "resources/ApiManager/api";
import strings from "resources/strings";
import {
  Typography,
  Flex,
  Space,
  Button,
  Modal,
  Card,
  Tag,
  Tooltip,
  theme,
  message,
} from "antd";
const { Text } = Typography;

import {
  Loading3QuartersOutlined,
  LockFilled,
  CreditCardFilled,
  CheckOutlined,
} from "@ant-design/icons";

import { CheckoutElementsProvider } from "@stripe/react-stripe-js/checkout";
import { loadStripe } from "@stripe/stripe-js";
import { PaymentElement, useCheckout } from "@stripe/react-stripe-js/checkout";
import { useStripe, Elements } from "@stripe/react-stripe-js";

import CONSTANTS from "shared/constants";

import "./style.scss";
import { min } from "lodash";

const stripePromise = loadStripe(CONSTANTS.STRIPE_API_PK);

const PaymentMethodIcon = ({ brand, wallet }) => {
  const { token: theme_token } = theme.useToken();

  const svgVisa = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="48"
      height="24"
      fill="none"
      viewBox="0 0 24 16"
    >
      <g clipPath="url(#clip0_4934_35103)">
        <path
          fill="#00579f"
          d="M22 0H2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h20a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2"
        ></path>
        <path
          fill="#fff"
          d="M10.367 10.91H8.85l.949-5.802h1.517zm5.501-5.66a3.8 3.8 0 0 0-1.36-.247c-1.5 0-2.555.79-2.561 1.92-.013.833.755 1.296 1.33 1.574.587.284.786.469.786.722-.006.389-.474.568-.91.568-.607 0-.931-.092-1.425-.309l-.2-.092-.212 1.302c.356.16 1.012.303 1.692.309 1.593 0 2.63-.778 2.642-1.982.006-.66-.4-1.166-1.274-1.58-.53-.265-.856-.444-.856-.716.006-.247.275-.5.874-.5.493-.012.856.105 1.13.222l.138.062z"
        ></path>
        <path
          fill="#fff"
          fillRule="evenodd"
          d="M18.584 5.108h1.174l1.224 5.802h-1.405l-.18-.87h-1.95c-.055.154-.318.87-.318.87h-1.592l2.254-5.32c.156-.377.431-.482.793-.482m-.093 2.124-.606 1.623h1.261c-.062-.29-.35-1.679-.35-1.679l-.106-.5a31 31 0 0 1-.2.556"
          clipRule="evenodd"
        ></path>
        <path
          fill="#fff"
          d="M7.582 5.108 6.096 9.065l-.162-.803c-.275-.926-1.136-1.931-2.098-2.432l1.361 5.074h1.605l2.385-5.796z"
        ></path>
        <path
          fill="#fff"
          d="M4.716 5.108H2.275l-.025.118c1.904.481 3.166 1.641 3.684 3.036l-.53-2.666c-.088-.37-.357-.475-.688-.488"
        ></path>
      </g>
      <defs>
        <clipPath id="clip0_4934_35103">
          <path fill="#fff" d="M0 0h24v16H0z"></path>
        </clipPath>
      </defs>
    </svg>
  );

  const svgMastercard = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="48"
      height="24"
      viewBox="0 0 24 16"
    >
      <rect fill="#252525" height="16" rx="2" width="24"></rect>
      <circle cx="9" cy="8" fill="#eb001b" r="5"></circle>
      <circle cx="15" cy="8" fill="#f79e1b" r="5"></circle>
      <path
        d="M12 4c1.214.912 2 2.364 2 4s-.786 3.088-2 4c-1.214-.912-2-2.364-2-4s.786-3.088 2-4z"
        fill="#ff5f00"
      ></path>
    </svg>
  );

  const svgAmex = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="48"
      height="24"
      fill="none"
      viewBox="0 0 24 16"
    >
      <g clipPath="url(#clip0_4934_35113)">
        <path
          fill="#0193ce"
          d="M22 0H2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h20a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2"
        ></path>
        <path
          fill="#fff"
          d="m19.127 8.063 2.278-2.333h-3.037l-.823.883-.696-.883h-3.505v.63h3.252l.949 1.135L18.62 6.36h1.139l-1.646 1.703 1.646 1.575h-1.14l-1.075-1.133-.986 1.133h-3.215v.632h3.505l.696-.883.823.883h3.037z"
        ></path>
        <path
          fill="#fff"
          d="M14.19 9.009h1.9l.885-.946-.76-.946h-2.024v.63h1.772v.631H14.19z"
        ></path>
        <path
          fill="#fff"
          fillRule="evenodd"
          d="m5.478 9.514-.262.756H2.595l2.228-4.54h2.102l.258.504V5.73h2.621l.525 1.261.524-1.261h2.49v4.54h-1.972v-.63l-.256.63H9.542l-.262-.63v.63H6.396l-.262-.756zm6.424.126h.782l.004-3.28h-1.31l-1.05 2.27L9.28 6.36H7.97v3.027L6.395 6.36H5.347L3.774 9.64h.918l.262-.757h1.704l.262.757h1.836V7.117l1.18 2.523h.786l1.18-2.523zM6.396 8.252l-.524-1.387-.656 1.387z"
          clipRule="evenodd"
        ></path>
      </g>
      <defs>
        <clipPath id="clip0_4934_35113">
          <path fill="#fff" d="M0 0h24v16H0z"></path>
        </clipPath>
      </defs>
    </svg>
  );

  const svgApplePay = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="#000000"
      width="35"
      height="23"
      viewBox="-4.5 3.5 40 24"
      style={{
        border: "1px solid #000000",
        borderRadius: "5px",
      }}
    >
      <path d="M5.849 11.047c-0.376 0.448-0.975 0.803-1.573 0.751-0.079-0.604 0.219-1.251 0.563-1.652 0.375-0.457 1.031-0.785 1.563-0.812 0.063 0.631-0.183 1.251-0.552 1.713zM6.396 11.917c-0.869-0.053-1.615 0.499-2.027 0.499-0.421 0-1.052-0.473-1.739-0.457-0.891 0.011-1.724 0.52-2.177 1.339-0.943 1.629-0.245 4.041 0.661 5.369 0.443 0.656 0.973 1.375 1.672 1.355 0.661-0.027 0.927-0.437 1.724-0.437 0.807 0 1.036 0.437 1.74 0.421 0.723-0.011 1.181-0.656 1.624-1.312 0.505-0.745 0.713-1.475 0.724-1.511-0.011-0.016-1.401-0.552-1.411-2.167-0.011-1.355 1.093-2 1.14-2.037-0.62-0.937-1.599-1.036-1.932-1.061zM11.412 10.083v9.855h1.515v-3.369h2.095c1.911 0 3.255-1.328 3.255-3.245 0-1.921-1.317-3.24-3.203-3.24zM12.927 11.375h1.745c1.312 0 2.063 0.708 2.063 1.953s-0.751 1.959-2.073 1.959h-1.735zM21.036 20.011c0.953 0 1.833-0.484 2.235-1.256h0.032v1.183h1.4v-4.907c0-1.416-1.124-2.337-2.859-2.337-1.604 0-2.792 0.932-2.833 2.208h1.359c0.115-0.609 0.667-1.005 1.433-1.005 0.927 0 1.443 0.437 1.443 1.24v0.541l-1.885 0.115c-1.761 0.109-2.709 0.833-2.709 2.099 0 1.276 0.98 2.12 2.385 2.12zM21.448 18.844c-0.808 0-1.323-0.391-1.323-0.989 0-0.62 0.495-0.985 1.437-1.043l1.683-0.104v0.557c0 0.923-0.776 1.579-1.803 1.579zM26.573 22.62c1.473 0 2.167-0.573 2.771-2.297l2.656-7.531h-1.536l-1.781 5.817h-0.032l-1.781-5.817h-1.583l2.563 7.172-0.136 0.437c-0.235 0.735-0.609 1.020-1.276 1.020-0.12 0-0.349-0.015-0.443-0.025v1.183c0.088 0.025 0.464 0.036 0.573 0.036z" />
    </svg>
  );

  const svgLink = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="40"
      height="22"
      viewBox="-8 0 90 24"
      style={{
        margin: "-6px",
        border: "1px solid #000000",
        borderRadius: "5px",
      }}
    >
      <path d="M36.12 3.67683c0-1.12801.9504-2.04481 2.0688-2.04481 1.1184 0 2.0688.9216 2.0688 2.04481 0 1.1232-.9168 2.0688-2.0688 2.0688-1.152 0-2.0688-.9168-2.0688-2.0688ZM29.9808 1.92001h3.6V22.08h-3.6V1.92001ZM40.008 7.68001h-3.6288V22.08h3.6288V7.68001ZM66.096 14.3904c2.7312-1.68 4.5888-4.1808 5.3232-6.71516h-3.6288c-.9456 2.41916-3.1152 4.23836-5.5008 5.01116V1.91523h-3.6288V22.0752h3.6288V16.08c2.7696.6912 4.9584 3.0864 5.7072 5.9952h3.6528c-.5568-3.0528-2.6448-5.9088-5.5536-7.6848ZM46.44 9.29283c.9504-1.2624 2.8032-1.99681 4.3056-1.99681 2.8032 0 5.1216 2.04961 5.1264 5.14558v9.6336h-3.6288v-8.832c0-1.272-.5664-2.7408-2.4048-2.7408-2.16 0-3.4032 1.9152-3.4032 4.1568v7.4256h-3.6288V7.68962H46.44v1.60321Z"></path>
      <circle cx="12" cy="12" r="12" fill="#00d66f"></circle>
      <path d="M11.4479 4.80005H7.74707c.72 3.0096 2.82243 5.58235 5.45283 7.19995-2.6352 1.6176-4.73283 4.1904-5.45283 7.2h3.70083c.9168-2.784 3.456-5.2032 6.576-5.6976v-3.0095c-3.1248-.4896-5.664-2.90885-6.576-5.69285Z"></path>
    </svg>
  );

  const brand_icons = {
    visa: svgVisa,
    mastercard: svgMastercard,
    amex: svgAmex,
  };

  const wallet_icons = {
    apple_pay: svgApplePay,
    link: svgLink,
  };

  return (
    <Flex
      align="center"
      gap={6}
      style={{
        marginLeft: "-5px",
        marginRight: "-5px",
      }}
    >
      {wallet_icons[wallet]}
      {brand
        ? brand_icons[brand] || (
            <CreditCardFilled
              style={{
                marginLeft: "5px",
                fontSize: "28px",
                color: theme_token.colorPrimary,
              }}
            />
          )
        : null}
    </Flex>
  );
};

const CurrentPaymentMethod = () => {
  const { isSmallView } = useWindowDimensions();

  const user = useStore((state) => state.user);

  return user.stripe.default_payment_method ? (
    <Card>
      <Flex justify="space-between" vertical={isSmallView} gap={10}>
        <Text strong style={{ fontSize: "16px" }}>
          Método de pago actual
        </Text>
        {user.stripe.default_payment_method.type === "card" ? (
          <Flex justify="flex-start" align="center" gap={10}>
            <PaymentMethodIcon
              brand={user.stripe.default_payment_method.brand}
              wallet={user.stripe.default_payment_method.wallet}
            />
            <Text strong style={{ fontSize: "16px" }}>
              •••• {user.stripe.default_payment_method.last4}
            </Text>
            <Tag>
              <Text>
                {user.stripe.default_payment_method.exp_month}/
                {user.stripe.default_payment_method.exp_year}
              </Text>
            </Tag>
          </Flex>
        ) : user.stripe.default_payment_method.type === "link" ? (
          <PaymentMethodIcon wallet={user.stripe.default_payment_method.type} />
        ) : (
          <Text style={{ fontSize: "16px", textTransform: "capitalize" }}>
            {user.stripe.default_payment_method.type}
          </Text>
        )}
      </Flex>
    </Card>
  ) : null;
};

export const FormattedAmount = ({ amountCents, currency, fontSize }) => {
  return (
    <Space>
      <Text style={{ fontWeight: "bold", fontSize: fontSize }}>
        <span style={{ whiteSpace: "nowrap" }}>
          ${" "}
          {(!!!amountCents || amountCents === 0
            ? 0
            : amountCents / 100
          ).toLocaleString("en-US", {
            //We check for 0 becaause Stripe returns -0 in some cases which results in us displaying as $ -0.00
            minimumFractionDigits: 2,
          })}
        </span>
      </Text>
      {currency && (
        <Tag color="blue" style={{ fontWeight: "normal", marginRight: "0px" }}>
          {currency.toUpperCase()}
        </Tag>
      )}
    </Space>
  );
};

const PaymentSummary = ({ interactionType, checkoutState }) => {
  const { token: theme_token } = theme.useToken();

  const intervalLocalization = {
    day: "dia",
    week: "semana",
    month: "mes",
    year: "año",
  };

  return checkoutState ? (
    <Flex vertical gap={10}>
      <Flex justify="space-between" align="center">
        <Text strong style={{ fontSize: "18px" }}>
          Plan seleccionado:
        </Text>
      </Flex>

      {checkoutState.checkout.lineItems.map((obj, i) => {
        return (
          <Flex justify="space-between" align="center" gap={10} key={"div" + i}>
            <Text key={"name" + i} strong style={{ fontSize: "15px" }}>
              {obj.name}
            </Text>
            <Flex justify="flex-end" gap={0}>
              <FormattedAmount
                key={"price" + i}
                fontSize={"15px"}
                amountCents={obj.total.minorUnitsAmount}
                currency={obj.total.currency}
              />
              {obj.recurring && (
                <Text
                  key={"recurring" + i}
                  strong
                  style={{ fontSize: "15px", textWrap: "nowrap" }}
                >
                  {"/" + intervalLocalization[obj.recurring.interval]}
                </Text>
              )}
            </Flex>
          </Flex>
        );
      })}

      {checkoutState.checkout.total.appliedBalance.minorUnitsAmount ? (
        <Flex justify="space-between" align="center" gap={10}>
          <Text strong style={{ fontSize: "15px" }}>
            Créditos aplicados:
          </Text>
          <FormattedAmount
            fontSize={"15px"}
            amountCents={
              checkoutState.checkout.total.appliedBalance.minorUnitsAmount
            }
            currency={checkoutState.checkout.currency}
          />
        </Flex>
      ) : null}

      <Flex justify="space-between" align="center" gap={10}>
        <Text strong style={{ fontSize: "15px" }}>
          Créditos restantes:
        </Text>
        <FormattedAmount
          fontSize={"15px"}
          amountCents={checkoutState.checkout.total.endingBalance}
          // ||
          //   user.stripe.credit_balance_cents + //we add because the checkout applied balance comes back negative
          //     checkoutState.checkout.total.appliedBalance.minorUnitsAmount
          currency={checkoutState.checkout.currency}
        />
      </Flex>

      <Flex justify="space-between" align="center" gap={10}>
        <Text strong style={{ fontSize: "18px" }}>
          Total a pagar:
        </Text>
        <FormattedAmount
          fontSize={"18px"}
          amountCents={checkoutState.checkout.total.total.minorUnitsAmount}
          currency={checkoutState.checkout.currency}
        />
      </Flex>
    </Flex>
  ) : (
    <Flex justify="center">
      <Loading3QuartersOutlined
        spin
        style={{
          marginTop: "20px",
          fontSize: "20px",
          color: theme_token.colorSecondary,
        }}
      />
    </Flex>
  );
};

const StripeCheckoutForm = ({
  isSubmitting,
  setIsSubmitting,
  interactionType,
}) => {
  const user = useStore((state) => state.user);
  const activeRfc = useStore((state) => state.activeRfc);

  const active_rfc_obj =
    activeRfc !== "nuevo-rfc" ? user.rfcs[activeRfc] : null;

  const { token: theme_token } = theme.useToken();
  const { isSmallView } = useWindowDimensions();

  const [message, setMessage] = useState(null);

  const checkoutState = useCheckout();

  if (checkoutState.type === "loading") {
    return (
      <Flex justify="center">
        <Loading3QuartersOutlined
          spin
          style={{
            marginTop: "20px",
            fontSize: "20px",
            color: theme_token.colorSecondary,
          }}
        />
      </Flex>
    );
  }

  if (checkoutState.type === "error") {
    return <div>Error: {checkoutState.error.message}</div>;
  }

  //Add the RFC to the first line item which corresponds to the selected plan
  if (checkoutState.checkout.lineItems[0]?.name) {
    checkoutState.checkout.lineItems[0].name = `${checkoutState.checkout.lineItems[0].name} (${active_rfc_obj.rfc})`;
  }

  const handleSubmit = async () => {
    const { checkout } = checkoutState;
    setIsSubmitting(true);

    const confirmResult = await checkout.confirm();

    // This point will only be reached if there is an immediate error when
    // confirming the payment. Otherwise, your customer will be redirected to
    // your `return_url`. For some payment methods like iDEAL, your customer will
    // be redirected to an intermediate site first to authorize the payment, then
    // redirected to the `return_url`.
    if (confirmResult.type === "error") {
      setMessage(confirmResult.error.message);
    }

    setIsSubmitting(false);
  };

  return (
    <Flex vertical gap={20}>
      <CurrentPaymentMethod />

      <Flex vertical gap={5}>
        <Text strong style={{ fontSize: "16px", marginTop: "10px" }}>
          {user.stripe.default_payment_method
            ? "Actualizar método de pago"
            : "Agregar método de pago"}
        </Text>
        <Text style={{ marginBottom: "10px" }}>
          Tu método de pago se actualizará con los nuevos datos y se usará para
          todos tus planes de RFCs.
        </Text>

        <PaymentElement />

        {/* <Text italic style={{ marginTop: "5px", marginBottom: "10px" }}>
          Los datos de tu método de pago son procesados de manera segura por{" "}
          <a
            href="https://stripe.com"
            target="_blank"
            rel="noopener noreferrer"
            style={{ textDecoration: "underline dotted" }}
          >
            stripe.com
          </a>
          .
        </Text> */}
      </Flex>

      {interactionType === "newSubscriptionPayment" && (
        <PaymentSummary
          interactionType={interactionType}
          checkoutState={checkoutState}
        />
      )}

      <Flex justify="flex-end" vertical={isSmallView}>
        <Button
          type="primary"
          icon={
            checkoutState.checkout.total.total.minorUnitsAmount === 0 ? (
              <CheckOutlined />
            ) : (
              <LockFilled />
            )
          }
          style={{ minWidth: "200px", color: "white !important" }}
          disabled={!checkoutState.checkout.canConfirm && !isSubmitting}
          loading={isSubmitting}
          onClick={handleSubmit}
        >
          {interactionType === "paymentMethodSetup"
            ? isSubmitting
              ? "Guardando..."
              : "Guardar"
            : interactionType === "newSubscriptionPayment"
              ? isSubmitting
                ? checkoutState.checkout.total.total.minorUnitsAmount === 0
                  ? "Confirmando..."
                  : "Pagando..."
                : checkoutState.checkout.total.total.minorUnitsAmount === 0
                  ? "Confirmar"
                  : "Pagar"
              : null}
        </Button>
      </Flex>
      {/* Show any error or success messages */}
      {message && <div>{message}</div>}
    </Flex>
  );
};

const ManualCheckoutForm = ({
  isSubmitting,
  setIsSubmitting,
  setIsModalOpen,
  interactionType,
  selectedPlan,
  rfc,
  showFeedbackSubscripctionUpgradeComplete,
}) => {
  const stripe = useStripe();

  const user = useStore((state) => state.user);
  const setUser = useStore((state) => state.setUser);
  const activeRfc = useStore((state) => state.activeRfc);
  const updateUserRfc = useStore((state) => state.updateUserRfc);

  const active_rfc_obj =
    activeRfc !== "nuevo-rfc" ? user.rfcs[activeRfc] : null;

  const { isSmallView } = useWindowDimensions();

  const [isLoading, setIsLoading] = useState(false);
  const [checkoutState, setCheckoutState] = useState(null);

  async function getInvoicePreview() {
    setIsLoading(true);
    try {
      const apiRes = await ApiManager.getUserSubscriptionUpdatesPreviewInvoice(
        active_rfc_obj.plan_name,
        selectedPlan,
      );

      //Silently return when error was for session expired, as the api handler will handle the message and redirection to /login
      if (
        apiRes.response.code === CONSTANTS.API_RESPONSE_ERROR_SESSION_EXPIRED
      ) {
        return null;
      }

      if (apiRes.response.code !== 2000) {
        return null;
      }

      const { preview_invoice, price_info } = apiRes.data;

      //Hydrate a simulated checkoutState using data from the upcoming invoice preview to populate the PaymentSummary
      const _checkoutState = {
        checkout: {
          currency: preview_invoice.currency,
          total: {
            total: {
              minorUnitsAmount: preview_invoice.amount_due,
            },
            appliedBalance: {
              minorUnitsAmount: min([
                preview_invoice.starting_balance,
                preview_invoice.amount_due,
              ]),
            },
            endingBalance: preview_invoice.ending_balance * -1,
          },
          lineItems: [
            {
              key: "item" + -1,
              name: `${price_info.product.name} (${active_rfc_obj.rfc})`,
              total: {
                minorUnitsAmount: price_info.unit_amount,
              },
              recurring: {
                interval: price_info.recurring.interval,
              },
            },
            ...preview_invoice.lines.data.map((i) => {
              return {
                key: "item" + i,
                name: i.description,
                total: {
                  minorUnitsAmount: i.amount,
                  currency: i.currency,
                },
              };
            }),
          ],
        },
      };

      setCheckoutState(_checkoutState);
    } catch (err) {
      console.error(err);
    } finally {
      setIsLoading(false);
    }
  }

  //Get the invoice preview on mount
  useEffect(() => {
    getInvoicePreview();
  }, []);

  //Refresh the invoice preview every 60s to get updated prorated values
  useEffect(() => {
    const intervalId = setInterval(() => {
      if (!isSubmitting) {
        getInvoicePreview();
      }
    }, 60000);

    return () => {
      clearInterval(intervalId);
    };
  }, [isSubmitting]);

  const handleSubmit = async () => {
    setIsSubmitting(true);

    function showSubscriptionUpdateFeedback() {
      const isPlanUpgrade =
        active_rfc_obj?.plan_name === "free" ||
        (active_rfc_obj?.plan_name === "basic" && selectedPlan === "pro");

      if (isPlanUpgrade) {
        showFeedbackSubscripctionUpgradeComplete();
      } else {
        message.success("Subscripción actualizada.");
      }
    }

    //Call server
    const apiRes = await ApiManager.postSubscriptionUpdate(rfc, selectedPlan);

    //Silently return when error was for session expired, as the api handler will handle the message and redirection to /login
    if (apiRes.response.code === CONSTANTS.API_RESPONSE_ERROR_SESSION_EXPIRED) {
      //No op
    } else if (apiRes.response.code === 5000) {
      message.error(apiRes.data.error_description_localized, 5);
    } else if (apiRes.response.code === 5001) {
      //Payment requires 3DS authentication
      const { error } = await stripe.confirmCardPayment(
        apiRes.data.client_secret,
      );

      if (error) {
        message.error(strings.alertPayment3DSFailed);
      } else {
        setIsSubmitting(false);
        window.location.href = `/plan?r=upgrade&p=${selectedPlan}`;
      }
    } else if (apiRes.response.code !== 2000) {
      message.error(strings.alertUnexpectedError);
    } else {
      if (user.stripe.subscription?.cancel_at) {
        setUser({
          ...user,
          stripe: {
            ...user.stripe,
            subscription: {
              ...user.stripe.subscription,
              cancel_at: null,
            },
          },
        });
      }
      updateUserRfc(apiRes.data.rfcs[0]);
      showSubscriptionUpdateFeedback();
    }

    setIsSubmitting(false);
    setIsModalOpen(false);
  };

  return (
    <Flex vertical gap={20}>
      <CurrentPaymentMethod />

      <PaymentSummary
        interactionType={interactionType}
        checkoutState={checkoutState}
      />

      <Flex justify="flex-end" vertical={isSmallView}>
        <Button
          type="primary"
          icon={
            checkoutState?.checkout.total.total.minorUnitsAmount === 0 ? (
              <CheckOutlined />
            ) : (
              <LockFilled />
            )
          }
          style={{
            minWidth: "200px",
            marginTop: "10px",
            color: "white !important",
          }}
          disabled={!!!user.stripe.has_default_payment_method || isLoading}
          loading={isSubmitting}
          onClick={handleSubmit}
        >
          {interactionType === "updateSubscriptionPayment"
            ? isSubmitting
              ? checkoutState?.checkout.total.total.minorUnitsAmount === 0
                ? "Confirmando..."
                : "Pagando..."
              : checkoutState?.checkout.total.total.minorUnitsAmount === 0
                ? "Confirmar"
                : "Pagar"
            : null}
        </Button>
      </Flex>
    </Flex>
  );
};

function ModalPaymentMethod({
  interactionType,
  rfc,
  selectedPlan,
  showFeedbackSubscripctionUpgradeComplete,
  disabled,
  buttonTooltipContent,
}) {
  const { token: theme_token } = theme.useToken();

  const user = useStore((state) => state.user);
  const activeRfc = useStore((state) => state.activeRfc);

  const active_rfc_obj =
    activeRfc !== "nuevo-rfc" ? user.rfcs[activeRfc] : null;

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [clientSecret, setClientSecret] = useState(null);
  const [loadingClientSecret, setLoadingClientSecret] = useState(false);

  const showModal = async () => {
    setIsModalOpen(true);

    if (clientSecret || interactionType === "updateSubscriptionPayment") {
      return;
    }

    setLoadingClientSecret(true);

    try {
      const isPlanUpgrade =
        active_rfc_obj?.plan_name === "free" ||
        (active_rfc_obj?.plan_name === "basic" && selectedPlan === "pro");

      const redirectValue = isPlanUpgrade
        ? `plan?r=upgrade&p=${selectedPlan}`
        : `plan?r=success&p=${selectedPlan}`;

      const apiRes =
        interactionType === "paymentMethodSetup"
          ? await ApiManager.getUserStripeCheckoutSession("cuenta?r=success")
          : interactionType === "newSubscriptionPayment"
            ? await ApiManager.getUserStripeCheckoutSession(
                redirectValue,
                rfc,
                selectedPlan,
              )
            : null;

      //Silently return when error was for session expired, as the api handler will handle the message and redirection to /login
      if (
        apiRes.response.code === CONSTANTS.API_RESPONSE_ERROR_SESSION_EXPIRED
      ) {
        return null;
      }

      if (apiRes.response.code !== 2000) {
        message.error(strings.alertUnexpectedError);
        handleCancel();
        return null;
      }

      setClientSecret(apiRes.data.client_secret);
    } catch (err) {
      console.error(err);
    } finally {
      setLoadingClientSecret(false);
    }
  };

  const handleCancel = () => {
    setIsSubmitting(false);
    setIsModalOpen(false);
    setClientSecret(null);
  };

  const appearance = {
    theme: "stripe",
    variables: {
      colorPrimary: theme_token.colorPrimary,
    },
  };

  const modalButtonText =
    interactionType === "paymentMethodSetup"
      ? user.stripe.has_default_payment_method
        ? "Administrar método de pago"
        : "Agregar método de pago"
      : "Seleccionar";

  const modalTitle =
    interactionType === "paymentMethodSetup"
      ? user.stripe.has_default_payment_method
        ? "Administrar método de pago"
        : "Agregar método de pago"
      : "Confirmación de pago";

  const modalButton = (
    <Button type="primary" onClick={showModal} disabled={disabled}>
      {modalButtonText}
    </Button>
  );

  return (
    <>
      {buttonTooltipContent ? (
        <Tooltip title={buttonTooltipContent}>{modalButton}</Tooltip>
      ) : (
        modalButton
      )}

      <Modal
        title={modalTitle}
        open={isModalOpen}
        onCancel={handleCancel}
        width={860}
        destroyOnClose={true}
        footer={null}
        maskClosable={!isSubmitting}
        closable={!isSubmitting}
      >
        <Flex vertical style={{ marginTop: "30px", marginBottom: "10px" }}>
          {interactionType === "updateSubscriptionPayment" ? (
            <Elements stripe={stripePromise}>
              <ManualCheckoutForm
                isSubmitting={isSubmitting}
                setIsSubmitting={setIsSubmitting}
                setIsModalOpen={setIsModalOpen}
                interactionType={interactionType}
                selectedPlan={selectedPlan}
                rfc={rfc}
                showFeedbackSubscripctionUpgradeComplete={
                  showFeedbackSubscripctionUpgradeComplete
                }
              />
            </Elements>
          ) : loadingClientSecret || !clientSecret ? (
            <Flex justify="center">
              <Loading3QuartersOutlined
                spin
                style={{
                  fontSize: "20px",
                  color: theme_token.colorSecondary,
                }}
              />
            </Flex>
          ) : (
            <CheckoutElementsProvider
              stripe={stripePromise}
              options={{
                clientSecret,
                elementsOptions: { appearance },
              }}
            >
              <StripeCheckoutForm
                isSubmitting={isSubmitting}
                setIsSubmitting={setIsSubmitting}
                interactionType={interactionType}
              />
            </CheckoutElementsProvider>
          )}
        </Flex>
      </Modal>
    </>
  );
}

export default ModalPaymentMethod;
